"use client";

import { createContext, use, type ReactNode } from "react";

const ReadableCopyContext = createContext<ReactNode>(null);

type ReadableCopyProps = {
  copy: ReactNode;
  children: ReactNode;
};

export function ReadableCopy({ copy, children }: ReadableCopyProps) {
  return <ReadableCopyContext value={copy}>{children}</ReadableCopyContext>;
}

export function readableFallback(placeholderClassName?: string) {
  return function ReadableFallback() {
    const copy = use(ReadableCopyContext);

    return (
      <>
        {placeholderClassName && (
          <div className={placeholderClassName} aria-hidden="true" />
        )}
        {/*
         * React throws away a client-only boundary's server fallback without
         * hydrating it, so the copy only exists in the server HTML, for clients
         * that read it without running JavaScript (AI agents, crawlers).
         * Browsers never render or hydrate it.
         */}
        {typeof window === "undefined" && copy && (
          <div className="sr-only" inert>
            {copy}
          </div>
        )}
      </>
    );
  };
}
